"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SectionHeader_1 = __importDefault(require("../../../../SectionHeader"));
var react_i18next_1 = require("react-i18next");
var ProjectCard_1 = __importDefault(require("./ProjectCard"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var AvailableProjects = function (_a) {
    var relatedPosts = _a.relatedPosts, developerLogo = _a.developerLogo, setIsRelatedPostClicked = _a.setIsRelatedPostClicked, isRelatedPostClicked = _a.isRelatedPostClicked;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SectionHeader_1.default, { title: t('POST_PREVIEW.DEVELOPER_INFO_SECTION.AVAILABLE_PROJECTS').toUpperCase() }),
        react_1.default.createElement("div", { className: classnames_1.default('ui two column doubling grid', styles_module_scss_1.default.container) }, relatedPosts === null || relatedPosts === void 0 ? void 0 : relatedPosts.map(function (item) { return (react_1.default.createElement(ProjectCard_1.default, { key: item.id, item: item, developerLogo: developerLogo, setIsRelatedPostClicked: setIsRelatedPostClicked, isRelatedPostClicked: isRelatedPostClicked })); }))));
};
exports.default = AvailableProjects;
